module.exports = {"441424103":"转水镇","441424108":"潭下镇","441424117":"郭田镇","441424118":"双华镇","441424125":"梅林镇","441424126":"华阳镇","441424130":"华城镇","441424131":"周江镇","441424134":"水寨镇","441424135":"河东镇","441424136":"岐岭镇","441424137":"长布镇","441424138":"横陂镇","441424139":"安流镇","441424140":"棉洋镇","441424141":"龙村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441424.json
// module id = 1854
// module chunks = 0